import {getActionCtaComponentFromTriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';
import type {JourneyStepTriggerWDto} from '@cohort/wallet-schemas/journeySteps';
import {Fragment} from 'react';

export type ActionCtaTrakingMetadata = {
  journeyId: string;
  appId: string;
  stepId: string;
  triggerId: string;
  journeyParticipationId: string;
};

type ActionCtaComponentWrapperProps = {
  trigger: JourneyStepTriggerWDto;
  processStepVerification: () => void;
  trackingData: ActionCtaTrakingMetadata;
  journeyId: string;
  journeyStepId: string;
};

const ActionCtaComponentWrapper: React.FC<ActionCtaComponentWrapperProps> = ({
  trigger,
  processStepVerification,
  trackingData,
  journeyId,
  journeyStepId,
}) => {
  const ActionCtaComponent = getActionCtaComponentFromTriggerIntegration(
    trigger.triggerIntegrationId
  );

  if (ActionCtaComponent === null) {
    return <Fragment />;
  }

  return (
    <div className="w-full md:w-auto">
      <ActionCtaComponent
        config={trigger.triggerIntegrationConfig}
        processStepVerification={processStepVerification}
        trackingData={trackingData}
        triggerId={trigger.id}
        journeyId={journeyId}
        stepId={journeyStepId}
      />
    </div>
  );
};

export default ActionCtaComponentWrapper;
